// src/helpers/gpxHelper.js
import L from 'leaflet';

/**
 * Finds the index of the closest point on a GPX route to the given lat/lon.
 *
 * @param {L.LatLng[]} routePoints - Array of Leaflet LatLngs from GPX.
 * @param {{ lat: number, lon: number }} target - GPS location to compare.
 * @returns {number} Index of the closest point in the route.
 */
export function findNearestRouteIndex(routePoints, target) {
  if (!Array.isArray(routePoints) || routePoints.length === 0 || !target?.lat || !target?.lon) {
    return -1;
  }

  const targetPoint = L.latLng(target.lat, target.lon);

  let nearestIndex = 0;
  let minDistance = routePoints[0].distanceTo(targetPoint);

  for (let i = 1; i < routePoints.length; i++) {
    const dist = routePoints[i].distanceTo(targetPoint);
    if (dist < minDistance) {
      minDistance = dist;
      nearestIndex = i;
    }
  }

  return nearestIndex;
}

/**
 * Calculates remaining distance (in km) from the current point to the end of the route.
 *
 * @param {L.LatLng[]} routePoints - Array of Leaflet LatLngs from GPX
 * @param {{ lat: number, lon: number }} currentTrackpoint - Current GPS position
 * @returns {number} Remaining distance in kilometers
 */
export function calculateDistanceToFinish(routePoints, currentPoint) {
  if (!routePoints?.length || !currentPoint?.lat || !currentPoint?.lon) return 0;

 const nearestIndex = findNearestRouteIndex(routePoints, currentPoint);

  if (nearestIndex === -1) return 0;

  let distance = 0;
  for (let i = nearestIndex; i < routePoints.length - 1; i++) {
    distance += routePoints[i].distanceTo(routePoints[i + 1]);
  }

  return distance / 1000; // → km
}
